import React from 'react';
import '../style';

const contentComponent = ({content , className}) => {
  return(
    <div className= {`main-content h-full overflow-auto ${className}`}>
      <p>{content}</p>
    </div>
  );
};
export default contentComponent;